<template>
  <div class="pc">
    <Nav/>
    <Home v-if="$store.getters.GetPath == 'Home'" class="pc-view"/>
    <Footer/>
  </div>
</template>

<script>
export default {
  name: "pc",
  components: {
    Nav: () => import(/* webpackChunkName: 'Nav' */ "./components/Nav"),
    Footer: () => import(/* webpackChunkName: 'Footer' */ "./components/Footer"),
    Home: () => import(/* webpackChunkName: 'Footer' */ "./views/home"),
  }
}
</script>

<style lang="less" scoped>
  .pc {
    font-size: 16px;
    .pc-view {
      margin: 80px 0 160px 0;
    }
  }
</style>
